/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesAgentCompletePartPreSignedUrlRequest {
    getFixupPrototypeFunction() { return KubernetesAgentCompletePartPreSignedUrlRequest.fixupPrototype; }

    static newInstance(model: Partial<KubernetesAgentCompletePartPreSignedUrlRequest>): KubernetesAgentCompletePartPreSignedUrlRequest {
        let obj = Object.assign(new KubernetesAgentCompletePartPreSignedUrlRequest(), model);
        KubernetesAgentCompletePartPreSignedUrlRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesAgentCompletePartPreSignedUrlRequest>): KubernetesAgentCompletePartPreSignedUrlRequest {
        if (!model) return null;
        return KubernetesAgentCompletePartPreSignedUrlRequest.newInstance(<KubernetesAgentCompletePartPreSignedUrlRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesAgentCompletePartPreSignedUrlRequest) {
        if (!obj) return;

        models.KubernetesAgentCompletePartPreSignedUrlRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesAgentCompletePartPreSignedUrlRequest): boolean {
        Object.setPrototypeOf(obj, KubernetesAgentCompletePartPreSignedUrlRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.multi_parts) {
            for (let val of this.multi_parts) {
                models.MultiPartDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the file
     */
    file_name: string;

    /**
     * Upload ID for the multipart upload
     */
    upload_id: string;

    multi_parts: Array<models.MultiPartDetail>;

}
